import React from 'react';
import Box from '@mui/material/Box';
import { TimeRange } from '../models/TimeRange.js';
import { MissionResultMap } from '../models/mission.js';
import { Link } from './Link.js';
import SearchIcon from '@mui/icons-material/Search';
import { DetailTable } from './DetailTable.js';

const SearchLink = ({
  pathname,
  query,
  children
}) => {
  const qs = new URLSearchParams(query).toString();
  const href = `${pathname}?${qs}`;
  return /*#__PURE__*/React.createElement(Link, {
    href: href
  }, children, /*#__PURE__*/React.createElement(SearchIcon, {
    sx: {
      fontSize: '0.8rem',
      ml: 0.25,
      mt: 0.5,
      transform: 'scale(-1, 1)'
    }
  }));
};
const MissionSearchLink = ({
  query,
  children
}) => /*#__PURE__*/React.createElement(SearchLink, {
  pathname: "/mission",
  query: query
}, children);
const MeetupSearchLink = ({
  query,
  children
}) => /*#__PURE__*/React.createElement(SearchLink, {
  pathname: "/meetup",
  query: query
}, children);
const MeetupDetailTable = ({
  item,
  sx
}) => {
  var _item$mission_list, _item$links;
  const statusMap = MissionResultMap[item.status];
  const tableItems = [{
    key: '状態',
    value: /*#__PURE__*/React.createElement("span", {
      style: {
        color: statusMap.color
      }
    }, `${statusMap.content} (${item.status})`)
  }, {
    key: '日時',
    value: item.datetime_format
  }, {
    key: '集会タイプ',
    value: item.type === 'live' ? '生中継の部 [LIVE]' : 'アーカイブの部 [ARCHIVE]'
  }, {
    key: '参加方法',
    value: `VRChat: ${item.user} にフレンド登録 & JOIN`
  }];
  if ((_item$mission_list = item.mission_list) != null && _item$mission_list.length) {
    tableItems.push({
      key: 'ミッション',
      value: item.mission_list.map(mission => /*#__PURE__*/React.createElement(Box, {
        key: mission.pk,
        sx: {
          mb: 1
        }
      }, /*#__PURE__*/React.createElement(Box, null, "\u65E5\u672C\u6642\u9593 ", mission.datetime_format), /*#__PURE__*/React.createElement(Link, {
        href: `/mission/detail?pk=${mission.pk}`
      }, mission.title)))
    });
  }
  if ((_item$links = item.links) != null && _item$links.length) {
    tableItems.push({
      key: '関連リンク',
      value: item.links.map(link => /*#__PURE__*/React.createElement(Box, {
        key: link.url
      }, /*#__PURE__*/React.createElement(Link, {
        href: link.url,
        external: true
      }, link.title)))
    });
  }
  tableItems.push({
    key: 'もっと調べる',
    value: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MeetupSearchLink, {
      query: {
        datetime: TimeRange.fromMode(item.datetime, 'YEAR').toString().replace('datetime=', '')
      }
    }, item.datetime.split('-')[0], "\u5E74 \u306E\u96C6\u4F1A\u4E00\u89A7"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(MissionSearchLink, {
      query: {
        datetime: TimeRange.fromMode(item.datetime, 'WEEK_TEIKI').toString().replace('datetime=', '')
      }
    }, "\u3053\u306E\u9031\u306E\u30DF\u30C3\u30B7\u30E7\u30F3\u4E00\u89A7"))
  });
  return /*#__PURE__*/React.createElement(DetailTable, {
    items: tableItems,
    sx: sx
  });
};

export { MeetupDetailTable, MeetupDetailTable as default };
